import { createWebHistory, createRouter } from 'vue-router'
/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
 noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
 title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
 icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
 breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
 activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
 }
 */

// 公共路由
export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login.vue'),
        hidden: true
    },
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/views/redirect/index.vue')
            }
        ]
    },
    {
        path: "/:pathMatch(.*)*",
        component: () => import('@/views/error/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () => import('@/views/error/401'),
        hidden: true
    },
    {
        path: '/workbench',
        component: () => import('@/views/redirect/workbench.vue'),
        name: 'WorkbenchRedirect',
        hidden: true
    },
    {
        path: '',
        component: Layout,
        redirect: '/workbench',
        children: [
            {
                path: '/index',
                component: () => import('@/views/redirect/workbench.vue'),
                name: 'Index',
                meta: { title: '首页', icon: 'dashboard', affix: true },
                roles: ['admin', 'common'],
            },
        ],
        hidden: true
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/loginbmd',
                component: () => import('@/views/home/loginbmd'),
                name: 'loginbmd',
                meta: { title: '跳转', icon: '' },
                roles: ['admin', 'common'],
            }
        ]
    },
    {
        path: '/user',
        component: Layout,
        hidden: true,
        redirect: 'noredirect',
        children: [
            {
                path: 'profile',
                component: () => import('@/views/system/user/profile/index'),
                name: 'Profile',
                meta: { title: '个人中心', icon: 'user' }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/ecommerce/batchEdit',
                component: () => import('@/views/pc-operation/ecommerce/batchEdit'),
                name: 'ecommerceBatchEdit',
                meta: { title: '电商产品批量编辑', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/quotation/edit',
                component: () => import('@/views/pc-operation/quotation/edit'),
                name: 'QuotationEdit',
                meta: { title: '报价信息', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/quotation/djeindex',
                component: () => import('@/views/pc-operation/quotation/djeindex'),
                name: 'DirectInquiryCenter',
                meta: { title: '定向询单中心', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/quotation/direct-form',
                component: () => import('@/views/pc-operation/quotation/directForm'),
                name: 'DirectInquiryForm',
                meta: {
                    title: '定向询单录入',
                    icon: '',
                    noCache: true,
                    activeMenu: '/direct-inquiry'
                },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/sales-work/quick-quote/form',
                component: () => import('@/views/pc-operation/quickQuote/form'),
                name: 'SalesQuickQuoteForm',
                meta: {
                    title: '快速报价录入',
                    noCache: true,
                    activeMenu: '/sales-work/quick-quote'
                },
            },
            {
                path: '/pc-operation/quickQuote/form',
                component: () => import('@/views/pc-operation/quickQuote/form'),
                name: 'QuickQuoteForm',
                meta: {
                    title: '快速报价录入',
                    icon: '',
                    noCache: true,
                    activeMenu: '/pricing/quick-quote'
                },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/quotation/djredit',
                component: () => import('@/views/pc-operation/quotation/djredit'),
                name: 'Quotationdjredit',
                meta: { title: '定价详情', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/pricing-quote-review/index',
                component: () => import('@/views/pc-operation/pricingQuoteReview/index'),
                name: 'PricingQuoteReviewTask',
                meta: { title: '定价复核任务', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/shippingorder/detailstd',
                component: () => import('@/views/pc-operation/shippingorder/detailstd'),
                name: 'Detailstd',
                meta: { title: '托单详情', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/shippingorder/placeanorder',
                component: () => import('@/views/pc-operation/shippingorder/placeanorder'),
                name: 'Placeanorder',
                meta: { title: '托单', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/shippingorder/expense',
                component: () => import('@/views/pc-operation/shippingorder/expense'),
                name: 'Expense',
                meta: { title: '费用', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/inquiry/index',
                component: () => import('@/views/pc-operation/inquiry/index'),
                name: 'inquiryindex',
                meta: { title: '询价', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/inquiry/xjdetails',
                component: () => import('@/views/pc-operation/inquiry/xjdetails'),
                name: 'xjdetails',
                meta: { title: '询价详情', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/shippingorder/trajectory',
                component: () => import('@/views/pc-operation/shippingorder/trajectory'),
                name: 'Trajectory',
                meta: { title: '流转日期', icon: '' },
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/pc-operation/bjsingle/addedit',
                component: () => import('@/views/pc-operation/bjsingle/addedit'),
                name: 'addedit',
                meta: { title: '报价信息', icon: '' },
            }
        ]
    },
     {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/kefu/shdetails',
                component: () => import('@/views/kefu/shdetails'),
                name: 'shdetails',
                meta: { title: '详情', icon: '' },
            }
        ]
    },
     {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/kefu/shedit',
                component: () => import('@/views/kefu/shedit'),
                name: 'shedit',
                meta: { title: '审核', icon: '' },
            }
        ]
    },

]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
    {
        path: '/system/user-auth',
        component: Layout,
        hidden: true,
        permissions: ['system:user:edit'],
        children: [
            {
                path: 'role/:userId(\\d+)',
                component: () => import('@/views/system/user/authRole'),
                name: 'AuthRole',
                meta: { title: '分配角色', activeMenu: '/system/user' }
            }
        ]
    },
    {
        path: '/system/platformUser-auth',
        component: Layout,
        hidden: true,
        permissions: ['gys:user:edit'],
        children: [
            {
                path: 'platformRole/:userId(\\d+)',
                component: () => import('@/views/system/platformUser/authRole'),
                name: 'AuthplatformRole',
                meta: { title: '分配角色', activeMenu: '/system/platformUser' }
            }
        ]
    },
    {
        path: '/system/role-auth',
        component: Layout,
        hidden: true,
        permissions: ['system:role:edit'],
        children: [
            {
                path: 'user/:roleId(\\d+)',
                component: () => import('@/views/system/role/authUser'),
                name: 'AuthUser',
                meta: { title: '分配用户', activeMenu: '/system/role' }
            }
        ]
    },
    {
        path: '/system/platformRole-auth',
        component: Layout,
        hidden: true,
        permissions: ['gys:role:edit'],
        children: [
            {
                path: 'platformUser/:roleId(\\d+)',
                component: () => import('@/views/system/platformRole/authUser'),
                name: 'AuthplatformUser',
                meta: { title: '分配用户', activeMenu: '/system/platformRole' }
            }
        ]
    },
    {
        path: '/system/dict-data',
        component: Layout,
        hidden: true,
        permissions: ['system:dict:list'],
        children: [
            {
                path: 'index/:dictId(\\d+)',
                component: () => import('@/views/system/dict/data'),
                name: 'Data',
                meta: { title: '字典数据', activeMenu: '/system/dict' }
            }
        ]
    },
    {
        path: '/monitor/job-log',
        component: Layout,
        hidden: true,
        permissions: ['monitor:job:list'],
        children: [
            {
                path: 'index/:jobId(\\d+)',
                component: () => import('@/views/monitor/job/log'),
                name: 'JobLog',
                meta: { title: '调度日志', activeMenu: '/monitor/job' }
            }
        ]
    },
    {
        path: '/tool/gen-edit',
        component: Layout,
        hidden: true,
        permissions: ['tool:gen:edit'],
        children: [
            {
                path: 'index/:tableId(\\d+)',
                component: () => import('@/views/tool/gen/editTable'),
                name: 'GenEdit',
                meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0 }
    },
});

export default router;
